import AgreementPage from "./AgreementPage";

export default AgreementPage;